import React from 'react';
import { QueryBuilderColumn } from './types';

interface PreviewTableProps {
  columns: QueryBuilderColumn[];
  rows: Array<Record<string, string | number | null>>;
  rowCount: number;
  truncated: boolean;
}

const PreviewTable: React.FC<PreviewTableProps> = ({ columns, rows, rowCount, truncated }) => {
  if (rows.length === 0) {
    return (
      <div className="p-6 text-center text-gray-500 bg-gray-50 rounded-lg border border-gray-200">
        No data found for the selected filters.
      </div>
    );
  }

  return (
    <div>
      <div className="flex items-center justify-between mb-2">
        <p className="text-sm font-medium text-gray-700">
          Preview (first 10 matching rows)
        </p>
        <p className="text-xs text-gray-500">
          {rowCount} row{rowCount !== 1 ? 's' : ''} returned
          {truncated && ' (truncated — full export includes all rows)'}
        </p>
      </div>
      <div className="overflow-x-auto rounded-lg border border-gray-200">
        <table className="min-w-full text-sm">
          <thead className="bg-gray-50">
            <tr>
              {columns.map((col) => (
                <th
                  key={col.key}
                  className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase tracking-wide whitespace-nowrap"
                >
                  {col.label}
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-100 bg-white">
            {rows.map((row, rowIndex) => (
              <tr key={rowIndex} className="hover:bg-gray-50">
                {columns.map((col) => {
                  const cellValue = row[col.key];
                  return (
                    <td
                      key={col.key}
                      className="px-4 py-3 text-gray-700 whitespace-nowrap"
                    >
                      {cellValue === null || cellValue === undefined ? '' : String(cellValue)}
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default PreviewTable;
